import { render, staticRenderFns } from "./right-side.vue?vue&type=template&id=dc9130e6&"
import script from "./right-side.vue?vue&type=script&lang=js&"
export * from "./right-side.vue?vue&type=script&lang=js&"
import style0 from "./right-side.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports